import React from 'react';

function HourSelect({ value, onChange, id, disabled }) {
  // Extract hour from time string (e.g., "17:00" -> 17)
  const currentHour = value ? parseInt(value.split(':')[0]) : 8;

  const handleChange = (e) => {
    const hour = e.target.value;
    // Always set minutes to :00
    const timeString = `${hour.padStart(2, '0')}:00`;
    onChange({ target: { value: timeString } });
  };

  return (
    <select
      id={id}
      value={currentHour.toString().padStart(2, '0')}
      onChange={handleChange}
      disabled={disabled}
    >
      {Array.from({ length: 24 }, (_, i) => (
        <option key={i} value={i.toString().padStart(2, '0')}>
          {i.toString().padStart(2, '0')}:00
        </option>
      ))}
    </select>
  );
}

export default HourSelect;
